import { createAction, props } from '@ngrx/store';
import { ShopifyError } from '../../models';

export const LoadOrders = createAction('[Orders] Load Orders');
export const LoadOrdersSuccess = createAction('[Orders] Load Orders Success', props<{ orders: any }>());
export const LoadOrdersFail = createAction('[Orders] Load Orders Fail', props<{ errors: ShopifyError[] }>());

export const LoadMoreOrders = createAction('[Products] Load More Orders');
